<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EgDisg/tc-custom/9780292793149.jpg?1705029192097" alt="This image is the cover for the book Tejano South Texas, Jack and Doris Smothers Series in Texas History, Life, and Culture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tejano South Texas, Jack and Doris Smothers Series in Texas History, Life, and Culture
      </h1>
      <p class="bookDescription body article font2">
        <p> On the plains between the San Antonio River and the Rio Grande lies the heartland of what is perhaps the largest ethnic region in the United States, Tejano South Texas. In this cultural geography, Daniel Arreola charts the many ways in which Texans of Mexican ancestry have established a cultural province in this Texas-Mexico borderland that is unlike any other Mexican American region. </p><p> Arreola begins by delineating South Texas as an environmental and cultural region. He then explores who the Tejanos are, where in Mexico they originated, and how and where they settled historically in South Texas. Moving into the present, he examines many factors that make Tejano South Texas distinctive from other Mexican American regions—the physical spaces of ranchos, plazas, barrios, and colonias; the cultural life of the small towns and the cities of San Antonio and Laredo; and the foods, public celebrations, and political attitudes that characterize the region. Arreola's findings thus offer a new appreciation for the great cultural diversity that exists within the Mexican American borderlands. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel D. Arreola
      </h2>
      
      <p class="authorDescription body article"> Daniel D. Arreola is Professor of Geography and an affiliate faculty member of the Center for Latin American Studies at Arizona State University. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ac0e162